import { store } from "store"

export namespace storage {
    export function load(urlkey: string, fallback: string = ""): string {
        return store.getItem(urlkey, fallback)
    }

    export function update(key: string, v: string): string {
        store.setItem(key, v)
        return v
    }

    export function remove(key: string,): void {
        store.removeItem(key)
    }
}
